<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour" :steps="steps" :callbacks="callbacksTour"></v-tour>
                            <h4 class="card-title">Gerar CTE Associado</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onImportXml()" v-b-tooltip title="Importar XML NFe" v-if="getPermission('xmlnfe.import')"><i class="ft-codepen"></i></a></li>
                                    <li><a @click="onImportXmlCte()" v-b-tooltip title="Importar XML CTe" v-if="getPermission('xmlcte.import')"><i class="ft-codepen"></i></a></li>
                                    <li><a @click="onCreateCteAssociado()" v-b-tooltip title="Gerar CTE Associado"><i class="ft-plus"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                        :load-on-start="false"
                    no-data-template="Para retornar algum dado, o usuário deve aplicar os filtros e clicar em filtrar"
                                        api-url="/api/gerarcteassociado"
                                        :fields="fields"
                                        :css="css"
                                        :append-params="moreParams"
                                        track-by="cardoc_id"
                                        pagination-path=""
                                        @vuetable:pagination-data="onPaginationData"
                                        @vuetable:loaded="onLoaded"
                                        detail-row-component="cte-associado-detalhes"
                                        @vuetable:cell-clicked="onDetail"
                                      >
                                      <template slot="selecionado" slot-scope="props">
                                          <b-form-checkbox buttons
                                                           button-variant="secondary"
                                                           v-model="props.rowData.selecionado"
                                                           value="1"
                                                           unchecked-value="2">
                                          </b-form-checkbox>
                                      </template>
                                      <template slot="tp_doc" slot-scope="props">
                                        <div class="custom-actions">
                                            <span v-if="props.rowData.doc_fiscal">
                                                {{ props.rowData.doc_fiscal.liv_tp_doc.descr }}
                                            </span>
                                            <span v-if="props.rowData.doc_transp">
                                                {{ props.rowData.doc_transp.liv_tp_doc.descr }}
                                            </span>
                                        </div>
                                      </template>

                                      <template slot="num_fiscal" slot-scope="props">
                                        <div class="custom-actions">
                                            <span v-if="props.rowData.doc_fiscal">
                                                {{ props.rowData.doc_fiscal.num_fiscal }}
                                            </span>
                                            <span v-if="props.rowData.doc_transp">
                                                {{ props.rowData.doc_transp.num_doc }}
                                            </span>
                                        </div>
                                      </template>

                                      <template slot="num_uc" slot-scope="props">
                                        {{ props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].num_uc }}
                                      </template>

                                      <template slot="num_carga" slot-scope="props">
                                        {{ props.rowData.carga.num_carga }}
                                      </template>

                                      <template slot="num_container" slot-scope="props">
                                        {{ props.rowData.carga.num_container }}
                                      </template>

                                      <template slot="pessoa" slot-scope="props">
                                          <span>{{ onFormataCnpj(props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pessoa_tomador.pessoa_juridica.cnpj_base,props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pessoa_tomador.pessoa_juridica.cnpj_filial,props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pessoa_tomador.pessoa_juridica.cnpj_digito)}} - {{ props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pessoa_tomador.pessoa_juridica.razao_social }}</span>
                                      </template>
                                      <template slot="status_uc" slot-scope="props">
                                            <span class="badge badge-info" v-if="props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.valor==1">{{ props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.descr }}</span>
                                            <span class="badge badge-warning" v-if="props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.valor==2">{{ props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.descr }}</span>
                                            <span class="badge badge-success" v-if="props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.valor==3">{{ props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.descr }}</span>
                                            <span class="badge badge-danger" v-if="props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.valor==4">{{ props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.descr }}</span>
                                      </template>
                                      <template slot="actions" slot-scope="props">
                                        <div class="custom-actions">
                                            <span v-if="props.rowData.doc_fiscal">
                                                <a @click="onCreateCteAssociadoUnit(props.rowData.cardoc_id, props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pedido_id, props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedunicar_id, props.rowData.doc_fiscal.num_fiscal, props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].num_uc)" v-b-tooltip title="Gerar CTE" v-if="getPermission('pedido.update')"><i class="fa fa-gear"></i></a>
                                            </span>
                                            <span v-if="props.rowData.doc_transp">
                                                <a @click="onCreateCteAssociadoUnit(props.rowData.cardoc_id, props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pedido_id, props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedunicar_id, props.rowData.doc_transp.num_doc, props.rowData.carga_doc_unidade_carga[0].pedido_unidade_carga[0].num_uc)" v-b-tooltip title="Gerar CTE" v-if="getPermission('pedido.update')"><i class="fa fa-gear"></i></a>
                                            </span>
                                        </div>
                                      </template>
                                  </vuetable>
                                </div>
                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"
                                            ></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"
                                            ></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal Component -->
            <b-modal id="modal_upload_xml"
                     ref="modal_upload_xml"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     v-model="showModalXml"
                     >
                     <div class="col-md-12 col-sm-12">
                         <label>Importar XML de NFe </label>
                         <vue-dropzone ref="myVueDropzone" id="dropzone"
                            :include-styling="true"
                             v-on:vdropzone-success="showSuccess"
                             v-on:vdropzone-error="showError"
                             v-on:vdropzone-sending="sendingEvent"
                             :options="dzOptions">
                         </vue-dropzone>
                     </div>
                 <div slot="modal-footer" class="w-100">
                        <div class="float-right">
                            <b-btn @click="showModalXml=false" variant="secondary">
                              Fechar
                            </b-btn>
                        </div>
                 </div>
            </b-modal>

            <!-- Modal Component -->
            <b-modal id="modal_upload_xml_cte"
                     ref="modal_upload_xml_cte"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     v-model="showModalXmlCTe"
                     >
                     <div class="col-md-12 col-sm-12">
                         <label>Importar XML de CTe </label>
                         <vue-dropzone ref="myVueDropzoneCTe" id="dropzoneCTe"
                            :include-styling="true"
                             v-on:vdropzone-success="showSuccess"
                             v-on:vdropzone-error="showErrorCTe"
                             v-on:vdropzone-sending="sendingEvent"
                             :options="dzOptionsCTe">
                         </vue-dropzone>
                     </div>
                     <div slot="modal-footer" class="w-100">
                         <div class="float-right">
                            <b-btn @click="showModalXmlCTe=false" variant="secondary">
                              Fechar
                            </b-btn>
                         </div>
                     </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import GerarCteAssociadoFilterBar from './GerarCteAssociadoFilterBar'
import moment from 'moment'
import {VMoney} from 'v-money'
import GerarCteAssociadoDetalhes from './GerarCteAssociadoDetalhes'
import vueDropzone from 'vue2-dropzone'

Vue.component('cte-associado-detalhes', GerarCteAssociadoDetalhes);


export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': GerarCteAssociadoFilterBar,
        VMoney,
        vueDropzone,
    },
    data () {
        return {
          dataExport: [],
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          showPopover: false,
          isLoadingTom: false,
          isLoadingFor: false,
          loading: false,
          isDisabled: false,
          loadingData: false,
          showModal: false,
          isFullscreen: false,
          showModalXml: false,
          showModalXmlCTe: false,
          optionsLivStatus: [],
          optionsStatus: [],
          errors_array: [],
          dzOptions: {
              url: "/api/xmlnfe",
              maxFiles: 10,
              maxFilesize: 1,
              addRemoveLinks: false,
              thumbnailWidth: 140,
              thumbnailHeight: 10,
              uploadMultiple: false,
              acceptedFiles: ".xml",
              dictDefaultMessage: 'Arraste os arquivos aqui, ou clique aqui. Limite de 10 arquivos',
              dictFallbackMessage: 'O seu browser não suporta arrastar para cá. Clique aqui.',
              dictFallbackText: "Use o formulário alternativo abaixo para envio.",
              dictFileTooBig: "Arquivo muito grande ({{filesize}}MiB). Tamanho máximo: {{maxFilesize}}MiB.",
              dictInvalidFileType: "Tipo do arquivo inválido para upload.",
              dictResponseError: "Server respondeu com código de erro {{statusCode}} code.",
              dictCancelUpload: "Cancelar envio",
              dictCancelUploadConfirmation: "Tem certeza que deseja cancelar o envio ?",
              dictRemoveFile: "Remover arquivo",
              dictMaxFilesExceeded: "Limite de envio excedido. Atualize a tela.",
              //headers: { "X-CSRF-TOKEN": document.head.querySelector('meta[name="csrf-token"]').content }
          },
          dzOptionsCTe: {
              url: "/api/xmlcte",
              maxFiles: 10,
              maxFilesize: 1,
              addRemoveLinks: false,
              thumbnailWidth: 140,
              thumbnailHeight: 10,
              uploadMultiple: false,
              acceptedFiles: ".xml",
              dictDefaultMessage: 'Arraste os arquivos aqui, ou clique aqui. Limite de 10 arquivos',
              dictFallbackMessage: 'O seu browser não suporta arrastar para cá. Clique aqui.',
              dictFallbackText: "Use o formulário alternativo abaixo para envio.",
              dictFileTooBig: "Arquivo muito grande ({{filesize}}MiB). Tamanho máximo: {{maxFilesize}}MiB.",
              dictInvalidFileType: "Tipo do arquivo inválido para upload.",
              dictResponseError: "Server respondeu com código de erro {{statusCode}} code.",
              dictCancelUpload: "Cancelar envio",
              dictCancelUploadConfirmation: "Tem certeza que deseja cancelar o envio ?",
              dictRemoveFile: "Remover arquivo",
              dictMaxFilesExceeded: "Limite de envio excedido. Atualize a tela.",
              //headers: { "X-CSRF-TOKEN": document.head.querySelector('meta[name="csrf-token"]').content }
          },
          formCte: new Form({ cardoc: [], pedunicar: [], pedido: [], tp_orig_doc: 2 }),
          helpForm: new Form({statusRecord: [], params: [],search:'', tp_orig_doc: 2}),
          fields: [
            {
                name: '__slot:selecionado',
                title: '',
            },
            {
                name: '__slot:tp_doc',
                title: 'Tipo Doc',
            },
            {
                name: '__slot:num_fiscal',
                title: 'N° Doc',
            },
            {
                name: '__slot:pessoa',
                title: 'Tomador'
            },
            {
                name: '__slot:num_uc',
                title: 'N° UC',
                sortField: 'num_uc'
            },
            {
                name: '__slot:num_carga',
                title: 'Carga',
            },
            {
                name: '__slot:num_container',
                title: 'Container',
            },
            {
                name: '__slot:status_uc',
                title: 'Status',
            },
            {
                name: '__slot:actions',
                title: 'Ações',
                titleClass: 'center aligned',
                dataClass: 'center aligned'
            }
       ],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        percentual_advalorem: VMoney
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getLivGeral();
      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.loadingData = true;
            this.moreParams = {
                'num_pedido': data_filter.num_pedido,
                'num_uc': data_filter.num_uc,
                'tom_cnpj': data_filter.tom_cnpj,
                'for_cnpj': data_filter.for_cnpj,
                'dt_inicio': data_filter.dt_inicio,
                'dt_fim': data_filter.dt_fim,
                'status': data_filter.status.value
            }
            Vue.nextTick( () => {this.$refs.vuetable.reload(); })
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        showSuccess: function (file, message, xhr) {
            this.$snotify.success(message+' para arquivo '+file.name);
            Vue.nextTick( () => this.$refs.vuetable.refresh());
        },
        showError: function (file, message, xhr) {
            this.$snotify.error(message+' para arquivo '+file.name);
        },
        showErrorCTe: function (file, message, xhr) {
            this.$snotify.error(message.message+' para arquivo '+file.name);
        },
        sendingEvent (file, xhr, formData) {
            formData.append('paramName', 'some value or other');
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.cardoc_id);
        },
        onImportXml (data) {
            this.modal_titulo = "Importar XML de NFe";
            this.modal_botao = "Importar";
            this.modal_acao = "i";
            this.loading = false;
            this.isDisabled = false;
            this.$refs.modal_upload_xml.show();
        },
        onImportXmlCte (data) {
            this.modal_titulo = "Importar XML de CTe";
            this.modal_botao = "Importar";
            this.modal_acao = "i";
            this.loading = false;
            this.isDisabled = false;
            this.$refs.modal_upload_xml_cte.show();
        },
        onCreateCteAssociadoUnit(cardoc_id, pedido_id, pedunicar_id, en_num_fiscal, ev_num_uc)
        {
            var vm = this;
            const onConfirmUnitWrapper = () => {
                confirmAssociadoUnitFn(vm);
            }

            let confirmAssociadoUnitFn = function(vm) {
                vm.formCte.cardoc = null;
                vm.formCte.cardoc = [];
                vm.formCte.pedunicar = null;
                vm.formCte.pedunicar = [];
                vm.formCte.pedido = null;
                vm.formCte.pedido = [];

                vm.formCte.pedunicar.push({ pedunicar_id: pedunicar_id });
                vm.formCte.cardoc.push({ cardoc_id: cardoc_id });
                vm.formCte.pedido.push({ pedido_id: pedido_id });

                if(vm.formCte.cardoc.length>0)
                {
                    vm.formCte.post('/api/gerarcteassociado/store').then(response =>
                    {
                        new ReturnApi(response, vm);
                    })
                    .catch(errors =>
                    {
                        new ReturnApi(errors, vm)
                    });
                }
            };

            let obj = {
              title: 'Gerar CTE Associado',
              message: 'Deseja gerar o CTE para a nota '+en_num_fiscal+' e unidade de carga '+ev_num_uc+' ? ',
              type: 'info',
              customCloseBtnText: 'Cancelar',
              customConfirmBtnText: 'Gerar',
              useConfirmBtn: true,
              onConfirm: onConfirmUnitWrapper
            }
            this.$Simplert.open(obj);
        },
        onCreateCteAssociado()
        {
            this.qtde_total = 0;
            this.$refs.vuetable.tableData.forEach((obj)=>{
                if(obj.selecionado==1)
                {
                    this.qtde_total = this.qtde_total+1;
                }
            });

            var vm = this;
            const onConfirmWrapper = () => {
                confirmAssociadoFn(vm);
            }

            let confirmAssociadoFn = function(vm) {
                vm.formCte.cardoc = null;
                vm.formCte.cardoc = [];
                vm.formCte.pedunicar = null;
                vm.formCte.pedunicar = [];
                vm.formCte.pedido = null;
                vm.formCte.pedido = [];

                vm.$refs.vuetable.tableData.forEach((obj)=>{
                    if(obj.selecionado==1)
                    {
                        vm.formCte.pedunicar.push({ pedunicar_id: obj.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedunicar_id });
                        vm.formCte.cardoc.push({ cardoc_id: obj.cardoc_id });
                        vm.formCte.pedido.push({ pedido_id: obj.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pedido_id });
                    }
                });

                if(vm.formCte.cardoc.length>0)
                {
                    vm.formCte.post('/api/gerarcteassociado/store').then(response =>
                    {
                        new ReturnApi(response, vm);
                    })
                    .catch(errors =>
                    {
                        new ReturnApi(errors, vm)
                    });
                }
            }

            let obj = {
              title: 'Gerar CTE Associado',
              message: 'Deseja gerar o CTE com um total de '+this.qtde_total+' documentos selecionados ? ',
              type: 'info',
              customCloseBtnText: 'Cancelar',
              customConfirmBtnText: 'Gerar',
              useConfirmBtn: true,
              onConfirm: onConfirmWrapper
            }
            this.$Simplert.open(obj);

        },
        formatDate (value, fmt = 'D MMM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD').format(fmt)
        },
        getLivGeral() {
            this.helpForm.get('/api/pedido/jsonlistGeral').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.param_cst.forEach((obj)=>
                {
                    this.optionsParamCst.push({ label: obj.descr, value: obj.parcst_id })
                })

                response.municipio.forEach((obj)=>
                {
                    this.optionsMunicipioIni.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id })
                    this.optionsMunicipioFim.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id })
                })
                response.cfop.forEach((obj)=>
                {
                    this.optionsCfop.push({ label: obj.descr, value: obj.cfop_id })
                })
                response.status.forEach((obj)=>
                {
                    this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_pedido.forEach((obj)=>
                {
                    this.optionsLivTpPedido.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_servico.forEach((obj)=>
                {
                    this.optionsLivTpServico.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_carga.forEach((obj)=>
                {
                    this.optionsLivTpCarga.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_fronteira.forEach((obj)=>
                {
                    this.optionsLivTpFronteira.push({ label: obj.descr, value: obj.valor })
                })
                response.exibe_advalorem_cfrete.forEach((obj)=>
                {
                    this.optionsLivAdvalorem.push({ label: obj.descr, value: obj.valor })
                })
                response.permite_adicionar_uc.forEach((obj)=>
                {
                    this.optionsLivAddUc.push({ label: obj.descr, value: obj.valor })
                })
                response.imposto_incluso.forEach((obj)=>
                {
                    this.optionsLivImpostoIncluso.push({ label: obj.descr, value: obj.valor })
                })
                response.status_trecho.forEach((obj)=>
                {
                    this.optionsLivStatusTrecho.push({ label: obj.descr, value: obj.valor })
                })
                response.b_modal.forEach((obj)=>
                {
                    this.optionsBModal.push({ label: obj.descr, value: obj.bmodal_id })
                })
                response.principal_trecho.forEach((obj)=>
                {
                    this.optionsLivPrincipal.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_trecho.forEach((obj)=>
                {
                    this.optionsLivTpTrecho.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_custo.forEach((obj)=>
                {
                    this.optionsLivTpCusto.push({ label: obj.descr, value: obj.valor })
                })
                response.status_trecho_custo.forEach((obj)=>
                {
                    this.optionsLivStatusTrechoCusto.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_custo_trecho.forEach((obj)=>
                {
                    this.optionsLivTpCustoTrecho.push({ label: obj.descr, value: obj.valor })
                })
                response.custo.forEach((obj)=>
                {
                    this.optionsCusto.push({ label: obj.descr, value: obj.custo_id })
                })
                response.tp_custo_pedido.forEach((obj)=>
                {
                    this.optionsLivTpCustoPedido.push({ label: obj.descr, value: obj.valor })
                })
                response.status_pedido_custo.forEach((obj)=>
                {
                    this.optionsLivStatusPedidoCusto.push({ label: obj.descr, value: obj.valor })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        listaClientesTomador(search) {
            if(search.length>=3)
            {
                this.isLoadingTom = true;
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsTomador = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsTomador.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingTom = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                  });
              }
          },
          listaClientesFornecedor(search) {
              if(search.length>=3)
              {
                  this.isLoadingFor = true;
                  this.helpForm.search = search;
                  this.helpForm.post('/api/pessoa/jsonlist/fornecedor').then(response =>
                  {
                      this.optionsFornecedor = [];
                      new ReturnApi(response, this, true, false, false);
                      response.items.forEach((obj)=>
                      {
                          this.optionsFornecedor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                      });
                      this.isLoadingFor = false;
                  })
                  .catch(errors =>
                  {
                      new ReturnApi(errors, this)
                    });
                }
            },
        onActivateDesactivate(action, data, tipo)
        {
            // Tipo = true = Checkbox
            if(tipo)
            {
                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.pedido_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }

            this.helpForm.post('/api/pedido/status').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });

        },
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
        {
            var cnpj_formatado
            var pad = "00000000"
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;

            return cnpj_base+""+cnpj_filial+""+cnpj_digito;
        },
        addRowTrecho: function(e) {
            e.preventDefault();
            this.trecho.push({
                ordem: "",
                principal: "",
                tp_trecho: [],
                modal: [],
                municipio_ini: [],
                municipio_fim: [],
                fornecedor: [],
                status: "",
                tp_custo: "",
                trecho_custo: [],
            });
        },
        removeRowTrecho: function(index) {
            this.trecho.splice(index, 1);
        },
        addRowTrechoCusto: function(e, row, index) {
            e.preventDefault();
            this.trecho[index].trecho_custo.push({
                valor: "",
                descr: "",
                tp_custo_trecho: [],
                custo: [],
            });
        },
        removeRowTrechoCusto: function(index,index2) {
            this.trecho[index].trecho_custo.splice(index, 1);
        },
        addRowPedidoCusto: function(e) {
            e.preventDefault();
            this.pedido_custo.push({
              valor: "",
              descr: "",
              tp_custo_pedido: [],
              custo: [],
              municipio: [],
              fornecedor: [],
            });
        },
        removeRowPedidoCusto: function(index) {
            this.pedido_custo.splice(index, 1);
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
          get () {
            return this.$store.state.vuetable.filterRow;
          },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
  }
  </script>
